import React, { useState } from "react";
import Navbar from "./Navbar";
import Section from "./Section";
import Labs from "./Labs";
import Tools from "./Tools";
import Certifications from "./Certifications";
import Resume from "./Resume";
import { motion } from "framer-motion";
import Home from "./Home";


const sections = [
  {id: "home",
  title: "Home"
},

  {id: "labs",
    title: "Labs",
  },
  {
    id: "tools",
    title: "Tools",
  },
  {
    id: "certifications",
    title: "Certifications",
  },
  {
    id: "resume",
    title: "Resume",
  },
 

];

export default function App() {
  const [activeSection, setActiveSection] = useState("home");
  const currentSection = sections.find((s) => s.id === activeSection);

  return (
    <>
      <Navbar onNavigate={setActiveSection} />
      <main className="container">
        <motion.div
          key={activeSection}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
        >
  {activeSection === "home" && <Home />}
{activeSection === "labs" && <Labs />}
{activeSection === "tools" && <Tools />}
{activeSection === "certifications" && <Certifications />}
{activeSection === "resume" && <Resume />}
{!currentSection && (
  <Section
    id={currentSection.id}
    title={currentSection.title}
    content={currentSection.content}
  />
)}



        </motion.div>
      </main>
    </>
  );
}
